import { render, staticRenderFns } from "./artefact-editor.vue?vue&type=template&id=17a27cb5&scoped=true&"
import script from "./artefact-editor.vue?vue&type=script&lang=ts&"
export * from "./artefact-editor.vue?vue&type=script&lang=ts&"
import style0 from "./artefact-editor.vue?vue&type=style&index=0&id=17a27cb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a27cb5",
  null
  
)

export default component.exports